import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Button from '@hapana/shared/web/components/shared/button/button.component'
import { BUTTON_VARIANTS } from '@hapana/shared/web/components/shared/button/button.constants'

import { styles } from './idle-warning-dialog.styles'

type IdleWarningDialogProps = {
  open: boolean
  secondsRemaining: number
  onStaySignedIn: () => void
  onSignOut: () => void
}

const IdleWarningDialog = ({
  open,
  secondsRemaining,
  onStaySignedIn,
  onSignOut,
}: IdleWarningDialogProps) => {
  const { t } = useTranslation('core')

  return (
    <Dialog open={open} onClose={onStaySignedIn} data-testid="idle-warning-dialog">
      <DialogTitle>{t('sessionPolicy.idleWarning.title')}</DialogTitle>
      <DialogContent sx={styles.content}>
        <Typography variant="body1" role="timer" aria-live="polite">
          {t('sessionPolicy.idleWarning.description', { count: secondsRemaining })}
        </Typography>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button
          data-testid="idle-warning-dialog-sign-out"
          label={t('sessionPolicy.idleWarning.signOut')}
          variant={BUTTON_VARIANTS.TEXT}
          onClick={onSignOut}
        />
        <Button
          data-testid="idle-warning-dialog-stay"
          label={t('sessionPolicy.idleWarning.stay')}
          variant={BUTTON_VARIANTS.CONTAINED}
          onClick={onStaySignedIn}
        />
      </DialogActions>
    </Dialog>
  )
}

export default IdleWarningDialog
